export default __webpack_public_path__ + "static/media/Cloud.1793e532.svg";